import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {catchError, map, Observable, throwError} from "rxjs";
import {MgoErrorProcessing} from "../models/MgoErrorProcessing";

@Injectable({
  providedIn: 'root'
})
export class MgoErrorService {
  private readonly url = environment.mgoErrorUrl;

  constructor(private readonly httpClient: HttpClient) { }

  public getAll(): Observable<MgoErrorProcessing[]> {
    return this.httpClient.get<MgoErrorProcessing[]>(this.url).pipe(map(
      allData => {
        return allData.map((allData) => {
          return MgoErrorProcessing.transformData(allData);
        })
      }),
      catchError(this.handleError));
  }

  public reprocessMgoFile(id: number, fileName: string, body: string): Observable<ArrayBuffer> {
    return this.httpClient.post<ArrayBuffer>(this.url + "/rep/" + id + "/" + fileName, body).pipe(
      catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

}
